const types = {
    FETCH_COLABORADORES: "@colaboradores/FETCH",
    UPDATE_COLABORADORES: "@colaboradores/UPDATE",
    UPDATE_COMPONENT: "@colaboradores/UPDATE_COMPONENT"
};

export default types;
